import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";

import PlantModuleNav from "./PlantModuleNav";
import ModuleIconBadge from "./ModuleIconBadge";
import useStandaloneView from "../hooks/useStandaloneView";

/**
 * The header every plant module page opens with: the module's badge and
 * title on the left, the plant it belongs to and the module launcher on the
 * right.
 *
 * `moduleKey` (optional) picks the badge - the same icon and colour the
 * sidebar tree gives that module (see constants/moduleVisuals.js).
 */
export default function PageHeader({ plant, pageTitle, moduleKey }) {
  const standalone = useStandaloneView();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 1.5,
        px: 2,
        pt: 1.5,
        pb: 1,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        {moduleKey && <ModuleIconBadge moduleKey={moduleKey} size="md" />}
        <Typography variant="h3" component="h1">
          {pageTitle}
        </Typography>
      </Box>

      <Box
        sx={{
          pl: 1,
          pr: 0.5,
          py: 0.5,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 180,
        }}
      >
        <ModuleIconBadge moduleKey="plant" size="sm" />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "0.7rem", lineHeight: 1 }}
          >
            Plant
          </Typography>
          {plant?.name ? (
            <Typography noWrap sx={{ fontWeight: 700, fontSize: "0.9rem" }}>
              {plant.name}
            </Typography>
          ) : (
            <Skeleton variant="text" width={140} />
          )}
        </Box>
        {!standalone && <PlantModuleNav plantId={plant?.id} compact />}
      </Box>
    </Box>
  );
}
